var colors = ["#9f9f9f", "#aaa", "#a9a9a9", "#bbb", "#b9b9b9", "#ccc"];

let polarData = [];

for (var i = 0; i <= 360; i++) {
  var t = (i / 180) * Math.PI;
  var r = Math.sin(3 * t) * Math.cos(3 * t);
  polarData.push([r, i]);
}

export const bar = {
  color: colors,
  legend: {
    bottom: 40,
    left: "center"
  },
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  grid: {
    left: "5%",
    right: "5%",
    bottom: "20%",
    containLabel: true
  },
  dataZoom: [
    {
      type: "slider"
    },
    {
      type: "inside"
    }
  ],
  tooltip: {},
  dataset: {
    source: [
      ["Number", "First", "Second"],
      ["Part 1", 43.3, 63.3],
      ["Part 2", 83.1, 73.1],
      ["Part 3", 76.4, 66.4],
      ["Part 4", 102.4, 72.4],
      ["Part 5", 43.3, 63.3],
      ["Part 6", 83.1, 73.1],
      ["Part 7", 76.4, 66.4],
      ["Part 8", 102.4, 72.4]
    ]
  },
  xAxis: { type: "category" },
  yAxis: {},
  series: [{ type: "bar" }, { type: "bar" }]
};

export const barX = {
  color: colors,
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow"
    }
  },
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  legend: {
    bottom: 10,
    left: "center",
    data: ["First", "Second"]
  },
  grid: {
    left: "3%",
    right: "10%",
    bottom: "10%",
    containLabel: true
  },
  dataZoom: [
    {
      type: "slider",
      yAxisIndex: 0
    },
    {
      type: "inside",
      yAxisIndex: 0
    }
  ],
  xAxis: {
    type: "value"
  },
  yAxis: {
    type: "category",
    data: ["1", "2", "3", "4", "5", "6", "7"]
  },
  series: [
    {
      name: "First",
      type: "bar",
      stack: "One",
      data: [320, 302, 301, 334, 390, 330, 320]
    },
    {
      name: "Second",
      type: "bar",
      stack: "One",
      data: [120, 132, 101, 134, 90, 230, 210]
    }
  ]
};

export const basic = {
  color: colors,
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      label: {
        backgroundColor: "#6a7985"
      }
    }
  },
  legend: {
    bottom: 40,
    left: "center",
    data: ["m2"]
  },
  dataZoom: [
    {
      type: "slider"
    },
    {
      type: "inside"
    }
  ],
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  grid: {
    left: "5%",
    right: "5%",
    bottom: "20%",
    containLabel: true
  },
  xAxis: [
    {
      type: "category",
      boundaryGap: false,
      data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    }
  ],
  yAxis: [
    {
      type: "value"
    }
  ],
  series: [
    {
      name: "m2",
      type: "line",
      areaStyle: {
        color: "#999"
      },
      smooth: true,
      data: [820, 932, 901, 934, 1290, 1330, 1320],
      lineStyle: {
        width: 1,
        color: "#999"
      },
      itemStyle: {
        color: "#999",
        borderColor: "#999"
      },
      symbol: "circle"
    }
  ],
  animationDuration: 500
};

export const pie = {
  color: colors,
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b} : {c} ({d}%)"
  },
  series: [
    {
      name: "Parts",
      type: "pie",
      radius: "55%",
      center: ["50%", "55%"],
      data: [
        { value: 335, name: "Part-1" },
        { value: 310, name: "Part-2" },
        { value: 234, name: "Part-3" },
        { value: 135, name: "Part-4" },
        { value: 844, name: "Part-5" },
        { value: 605, name: "Part-6" }
      ],
      itemStyle: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: "rgba(0, 0, 0, 0.5)"
      }
    }
  ],
  animationDuration: 500
};

export const doughnut = {
  color: colors,
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b}: {c} ({d}%)"
  },
  legend: {
    bottom: 10,
    left: "center",
    data: ["One", "Two", "Three", "Four", "Five"]
  },
  series: [
    {
      name: "Donuts",
      type: "pie",
      radius: ["30%", "70%"],
      avoidLabelOverlap: false,
      label: {
        normal: {
          show: false,
          position: "center"
        },
        emphasis: {
          show: true,
          textStyle: {
            fontSize: "16",
            fontWeight: "bold"
          }
        }
      },
      labelLine: {
        normal: {
          show: false
        }
      },
      data: [
        { value: 335, name: "One" },
        { value: 310, name: "Two" },
        { value: 234, name: "Three" },
        { value: 135, name: "Four" },
        { value: 1548, name: "Five" }
      ],
      itemStyle: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: "rgba(0, 0, 0, 0.5)"
      }
    }
  ],
  animationDuration: 500
};

export const pieRose = {
  color: colors,
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  tooltip: {
    trigger: "item",
    formatter: "{a} <br/>{b} : {c} ({d}%)"
  },
  series: [
    {
      name: "Parts",
      type: "pie",
      radius: "55%",
      center: ["50%", "55%"],
      data: [
        { value: 335, name: "Part-1" },
        { value: 274, name: "Part-2" },
        { value: 310, name: "Part-3" },
        { value: 235, name: "Part-4" },
        { value: 400, name: "Part-5" }
      ].sort(function(a, b) {
        return a.value - b.value;
      }),
      roseType: "radius",
      label: {
        normal: {
          textStyle: {}
        }
      },
      labelLine: {
        normal: {
          lineStyle: {},
          smooth: 0.2,
          length: 10,
          length2: 20
        }
      },
      itemStyle: {
        normal: {
          shadowBlur: 25,
          shadowColor: "rgba(0, 0, 0, 0.5)"
        }
      },
      animationType: "scale",
      animationEasing: "elasticOut",
      animationDelay: function() {
        return Math.random() * 200;
      }
    }
  ]
};

export const polar = {
  color: colors,
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  legend: {
    bottom: 10,
    left: "center",
    data: ["line"]
  },
  polar: {
    center: ["50%", "50%"],
    radius: "65%"
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross"
    }
  },
  angleAxis: {
    type: "value",
    startAngle: 0
  },
  radiusAxis: {
    min: 0
  },
  series: [
    {
      coordinateSystem: "polar",
      name: "line",
      type: "line",
      showSymbol: false,
      data: polarData,
      lineStyle: {
        width: 1
      }
    }
  ],
  animationDuration: 500
};

export const scatter = {
  color: colors,
  grid: {
    right: "10%",
    containLabel: true
  },
  toolbox: {
    feature: {
      saveAsImage: {
        title: "PNG"
      }
    }
  },
  legend: {
    bottom: 10,
    left: "center",
    data: ["Peas"]
  },
  xAxis: {},
  yAxis: {},
  series: [
    {
      type: "scatter",
      name: "Peas",
      symbolSize: 20,
      data: [
        [10.0, 8.04],
        [8.0, 6.95],
        [13.0, 7.58],
        [9.0, 8.81],
        [11.0, 8.33],
        [14.0, 9.96],
        [6.0, 7.24],
        [4.0, 4.26],
        [12.0, 10.84],
        [7.0, 4.82],
        [5.0, 5.68]
      ],
      itemStyle: {
        shadowBlur: 5,
        shadowOffsetX: 0,
        shadowColor: "rgba(200, 200, 200, 0.8)"
      }
    }
  ]
};
